<template>
  <div class="cookies">
    <p>This site uses cookies to ensure you get the best experience.</p>
    <div class="options">
      <a>More Info Pls</a>
      <a @click="giveConsent()">OK</a>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'Cookies',
  methods: {
    ...mapActions(['cookieConsent']),
    giveConsent () {
      this.cookieConsent()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='scss'>
.cookies {
  background: #fff;
  color: #000;
  font-family: arial, sans-serif;
  font-size: 0.75rem;
  padding: 8px 20px 8px 10px;

  .options {
    float: right;

    a {
      margin-left: 10px;
      cursor: pointer;
    }
  }
}

p {
  margin: 0;
  display: inline-block;
}

</style>



// WEBPACK FOOTER //
// src/components/Cookies.vue